module.exports = __webpack_public_path__ + "static/img/Noise_NNpsk2.0fb9887.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/handshakes/assets/Noise_NNpsk2.png
// module id = rYHo
// module chunks = 1